import React from "react";
import "./SupportCenter.scss";
import { IoMdArrowRoundBack } from "react-icons/io";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

const SupportCenter = () => {

  const navigate = useNavigate();

  return (
    <div>
      <div className="headerMain_Page" style={{position: 'fixed'}}>
        <Button className="back_Button" onClick={() => navigate(-1)}>
          <IoMdArrowRoundBack
            style={{ color: "white", height: "30px", width: "30px" }}
          />
        </Button>
        <p
          style={{
            color: "white",
            width: "80%",
            fontWeight: 600,
            margin: '0px',
            fontSize: "18px",
          }}
        >
          Support
        </p>
      </div>
      <div className="support-container">
        <h1>Support for Sales Rep App</h1>
        <p>
          We are committed to providing excellent support for all users of the
          Sales Rep App. If you encounter any issues or need assistance with the
          app's features, you can reach us through the following channels:
        </p>
        <h2>How to Get Help</h2>
        <p>
          If you need further assistance, you can contact our support team using
          the options below:
        </p>
        <ul>
          <li>Email Support: support@orail.in</li>
          <li>Phone Support: 0261-3603500</li>
        </ul>

        <h2>User Guides and Tutorials</h2>
        <p>
          Explore step-by-step guides and video tutorials for using the Sales
          Rep App. Whether you need help managing customer data, sharing
          catalogs, or generating sales reports, our resources are here to help
          you.
        </p>

        <h2>System Status and Updates</h2>
        <p>
          Check for any ongoing issues, scheduled maintenance, or system updates
          that may impact app performance.
        </p>

        <h2>Support Hours</h2>
        <p>Our support team is available during the following hours:</p>
        <ul>
          <li>Monday to Saturday: 9:30 AM - 6:30 PM (EST)</li>
          <li>Sunday: Closed</li>
        </ul>
        <p>
          For any inquiries outside these hours, please feel free to email us,
          and we’ll get back to you as soon as possible.
        </p>

        <h2>Feedback and Suggestions</h2>
        <p>
          We value your input! Share your feedback and suggestions for improving
          the Sales Rep App by emailing us at Support@orail.in.
        </p>
      </div>
    </div>
  );
};

export default SupportCenter;
